import script from "./WidgetNouveautes.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetNouveautes.vue?vue&type=script&setup=true&lang=js"

import "./WidgetNouveautes.vue?vue&type=style&index=0&id=711b7d7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711b7d7d"]])

export default __exports__